import React from 'react'
import { Navigate, useLocation } from "react-router-dom";
import { secretStorage } from 'config';
import { app } from './routes';
import { CreateTicketAlert } from 'pages/CreateTicket';
import { useSelector } from 'react-redux';
import { alerts as alertKeys } from 'keys'

const PrivateRoutesAuth = (props) => {
    const token = secretStorage.getItem("user")?.token;
    const isAuth = !!token; // Assuming getToken() returns truthy value when token is present

    const location = useLocation()
    const { alerts } = useSelector(state => state.general)

    const from = location.state?.from || "/";

    if (isAuth)
        return <Navigate to={from.pathname || app.app} replace />


    return (
        <React.Fragment>
            {alerts[alertKeys.contactUs].open && <CreateTicketAlert />}
            {props.children}
        </React.Fragment>
    )
}

export default PrivateRoutesAuth